// import cv from "./CV.pdf";

export const socialLinks = [
	{ name: "Resume", link: 'https://drive.google.com/file/d/1y0Yy3Dpi3zvrx1FE-4HwiyRZ61CqIiPk/view?usp=drive_link'},
	{ name: 'Telegram', link: 'https://t.me/turboy01' },
	{ name: 'Mail', link: 'mailto: noakosar@gmail.com' },
	{ name: 'WhatsApp', link: 'https://wa.me/+381 62 117 6750'},
	{ name: 'linkedin', link: 'https://www.linkedin.com/in/noa-kosar-a63a902a5'},
	{ name: 'Skype', link: 'https://join.skype.com/invite/rXJwfq0EAQC5'},
	// { name: 'Github', link: 'https://github.com/cedev935' },
	// { name: 'discord', link: 'noa_anna'},
	// { name: 'Slack', link: 'https://superstarsworkplace.slack.com/archives/D05PGSVAX24'},
];
